import React from 'react';
import { useAppDispatch, useAuthState, useModalState } from '@core/configureStore';
import { closeModal } from '@core/features';
import { Divider, Modal } from 'antd';
import { ReservationFormContainer } from '..';
import { fetchReservations } from '@core/features/booking/thunks/fetchReservations.thunk';

const AddNewReservationModal = () => {
  const dispatch = useAppDispatch();
  const { user } = useAuthState();
  const { addNewReservationModal } = useModalState();
  const handleModalClose = () => {
    dispatch(
      closeModal({
        modalName: 'addNewReservationModal',
      })
    );
  };

  const handleOk = () => {
    handleModalClose();
  };

  return (
    <Modal
      title={'Add a reservation'}
      open={addNewReservationModal}
      onOk={handleOk}
      onCancel={handleModalClose}
      footer={[]}
      closable>
      <Divider />
      <ReservationFormContainer
        propsLocationId={user?.selected_location?.location_id}
        onUpdated={async () => {
          await dispatch(fetchReservations());
          handleModalClose();
        }}
      />
    </Modal>
  );
};

export default AddNewReservationModal;
